export default __webpack_public_path__ + "static/fantasy_2-f326593fdc7ddedd6f972a6732449eda.png";